import { TIME_OF_DAY_FOR_SLOTS } from "@elixir/types";
import { isSameDay } from "./date-utils";

export function getTimeOfDaysForDate(date: Date): TIME_OF_DAY_FOR_SLOTS[] {
  const now = new Date();
  if (isSameDay(date, now)) {
    const hourOfTheDay = now.getHours();
    if (hourOfTheDay >= 0 && hourOfTheDay < 12) {
      return [
        TIME_OF_DAY_FOR_SLOTS.MORNING,
        TIME_OF_DAY_FOR_SLOTS.AFTERNOON,
        TIME_OF_DAY_FOR_SLOTS.EVENING,
      ];
    } else if (hourOfTheDay >= 12 && hourOfTheDay < 17) {
      return [TIME_OF_DAY_FOR_SLOTS.AFTERNOON, TIME_OF_DAY_FOR_SLOTS.EVENING];
    } else {
      return [TIME_OF_DAY_FOR_SLOTS.EVENING];
    }
  }
  return [
    TIME_OF_DAY_FOR_SLOTS.MORNING,
    TIME_OF_DAY_FOR_SLOTS.AFTERNOON,
    TIME_OF_DAY_FOR_SLOTS.EVENING,
  ];
}

export function getTimeOfDaysApplicable(date: Date): TIME_OF_DAY_FOR_SLOTS {
  const today = new Date();
  const timeOfDayProvided = date.getTime();

  let dateTimeToConsider: Date = date;
  if (timeOfDayProvided < today.getTime()) {
    dateTimeToConsider = today;
  }

  return getTimeOfDay(dateTimeToConsider);
}

export function getTimeOfDay(date: Date): TIME_OF_DAY_FOR_SLOTS {
  const hourOfTheDay = date.getHours();
  if (hourOfTheDay >= 0 && hourOfTheDay < 12) {
    return TIME_OF_DAY_FOR_SLOTS.MORNING;
  } else if (hourOfTheDay >= 12 && hourOfTheDay < 17) {
    return TIME_OF_DAY_FOR_SLOTS.AFTERNOON;
  } else {
    return TIME_OF_DAY_FOR_SLOTS.EVENING;
  }
}

export const convertMinutesToHours = (minutes: number) => {
  if (minutes < 60) {
    return `${minutes} min`;
  }
  const hours = Math.floor(minutes / 60);
  const remainingMinutes = minutes % 60;
  if (remainingMinutes > 0) {
    return `${hours} hr ${remainingMinutes} min`;
  }
  return `${hours} hr`;
};
